import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProjectStore } from '../stores/projectStore';
import { Header } from '../components/shared/Header';
import { Sidebar } from '../components/editor/Sidebar';
import { TimelineCanvas } from '../components/canvas/TimelineCanvas';
import { ShareModal } from '../components/shared/ShareModal';
import { ViewControls } from '../components/shared/ViewControls';
export function EditPage() {
    const { projectId, editSecret } = useParams();
    const navigate = useNavigate();
    const { loadProject, isLoading, error, shareModalOpen } = useProjectStore();
    useEffect(() => {
        if (!projectId || !editSecret) {
            navigate('/');
            return;
        }
        loadProject(projectId, editSecret).catch(() => {
            // Error handled in store
        });
    }, [projectId, editSecret]);
    if (isLoading) {
        return (_jsx("div", { className: "flex items-center justify-center h-screen bg-white dark:bg-neutral-950", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "w-8 h-8 rounded-full border-2 border-indigo-600 border-t-transparent animate-spin mx-auto mb-3" }), _jsx("p", { className: "text-sm text-gray-500 dark:text-gray-400", children: "Loading project\u2026" })] }) }));
    }
    if (error) {
        return (_jsx("div", { className: "flex items-center justify-center h-screen bg-white dark:bg-neutral-950", children: _jsxs("div", { className: "text-center max-w-xs", children: [_jsx("div", { className: "text-4xl mb-4", children: "\uD83D\uDD12" }), _jsx("h2", { className: "text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2", children: "Unable to load project" }), _jsx("p", { className: "text-sm text-gray-500 dark:text-gray-400 mb-6", children: error }), _jsx("button", { onClick: () => navigate('/'), className: "px-4 py-2 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700", children: "Go Home" })] }) }));
    }
    return (_jsxs("div", { className: "flex flex-col h-screen overflow-hidden bg-white dark:bg-neutral-950", children: [_jsx(Header, { mode: "edit" }), _jsxs("div", { className: "flex flex-1 overflow-hidden", children: [_jsx(Sidebar, {}), _jsxs("main", { className: "flex-1 relative overflow-hidden", children: [_jsx(TimelineCanvas, { readOnly: false }), _jsx(ViewControls, {})] })] }), shareModalOpen && _jsx(ShareModal, {})] }));
}
